import { Box } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { match } from 'ts-pattern';
import { FallbackImage } from '~/components/FallbackImage';
import Tooltip from '~/components/Tooltip';
import { VideoHover } from '~/components/VideoHover';
import { ContentImage } from '~/screens/SearchContent/components/ContentImage';
import { ASSET_TYPE } from '~/searchApi/content';

interface ICarouselNotClicableItemProps {
  url: string;
  type: ASSET_TYPE | null;
  previewUrl: string | undefined;
  caption: string;
}

export const CarouselNotClicableItem: React.FC<
  ICarouselNotClicableItemProps
> = ({ url, type, previewUrl, caption }) => {
  const tooltipLabel = `Sorry, this content link isn't available from Instagram`;

  return (
    <Tooltip isTouchFriendly label={tooltipLabel} hasArrow>
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        overflow="hidden"
        borderRadius="lg"
        _hover={{
          cursor: 'default',
        }}
        data-testid="carousel-item-expired"
      >
        {match(type?.toLowerCase())
          .with(ASSET_TYPE.video, () => (
            <VideoHover
              src={url}
              poster={previewUrl}
              width="100%"
              height="100%"
              objectFit="cover"
              containerProps={{
                height: '100%',
              }}
              fallback={
                <FallbackImage
                  width="100%"
                  height="100%"
                  objectFit="cover"
                  iconProps={{ boxSize: 8 }}
                />
              }
            />
          ))
          .otherwise(() => (
            <ContentImage
              position="absolute"
              draggable="false"
              width="100%"
              height="100%"
              top={0}
              src={isEmpty(url) ? previewUrl : url}
              alt={caption}
              objectFit="cover"
              background="white"
              fallbackImageProps={{
                width: '100%',
                height: '100%',
                iconProps: {
                  boxSize: 8,
                },
              }}
            />
          ))}
      </Box>
    </Tooltip>
  );
};
